/*proj4/lib/parseCode*/
function _(require, module, exports) {
    var defs = require(367    /* ./defs */);
    var wkt = require(377    /* ./wkt */);
    var projStr = require(372    /* ./projString */);
    function testObj(code) {
        return typeof code === 'string';
    }
    function testDef(code) {
        return code in defs;
    }
    var codeWords = [
        'GEOGCS',
        'GEOCCS',
        'PROJCS',
        'LOCAL_CS'
    ];
    function testWKT(code) {
        return codeWords.some(function (word) {
            return code.indexOf(word) > -1;
        });
    }
    function testProj(code) {
        return code[0] === '+';
    }
    function parse(code) {
        if (testObj(code)) {
            //check to see if this is a WKT string
            if (testDef(code)) {
                return defs[code];
            }
            if (testWKT(code)) {
                return wkt(code);
            }
            if (testProj(code)) {
                return projStr(code);
            }
        } else {
            return code;
        }
    }
    module.exports = parse;
}